module.exports = __webpack_public_path__ + "img/LOGO_NAEGA_DI_white.2f02c29e.svg";